// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1u4H_","row":"Node_row__1MeRl","label":"Node_label__1aqBm","footer":"Node_footer__1KzFJ"};